import React from 'react';
import { metadataDefaultsMapGenerator } from './defaults';
import _ from 'lodash';
const booleanMetadataGenerator = (truthyLabel = 'Yes', falsyLabel = 'No', truthyColor = '#009900', falsyColor = '#990000') => {
    return {
        format: {
            truthy: {
                label: truthyLabel,
                color: truthyColor,
            },
            falsy: {
                label: falsyLabel,
                color: falsyColor,
            },
        }
    };
};
/**
 * Renders the received value depending on the metadata set by the user
 *
 * @param {any} t The translate function
 * @param {any} v The actual value of the leaf
 * @param {FieldMetadata} metadata OPTIONAL - metadata of the current field
 * @param {string[]} context OPTIONAL - context to check if value is in the ignore array
 * @param {any} data OPTIONAL - data of the hole row
 * @param {number} indentLevel Number representing depth within an object or array
 * @param {MetadataTypes} type type of the metadata
 *
 * @return {JSX.Element | string} renderValue the actual object created
 */
export function renderValue(t, v, metadata, context, data, indentLevel = 0, type, path = '', field) {
    const entity = data.entity;
    let dictionary = {};
    if (context && context.dictionary) {
        dictionary = Object.assign(Object.assign({}, context.dictionary[entity]), context.dictionary['*']);
    }
    if (metadata && metadata.callback) {
        return metadata.callback(v, data, field);
    }
    if (v === undefined || v === null) {
        return React.createElement("span", { style: { color: '#999999' } }, (metadata && metadata.ifNull) || '');
    }
    const TYPE = (metadata === null || metadata === void 0 ? void 0 : metadata.type) || getType(v);
    switch (TYPE) {
        case 'BOOL':
            const FIXED_BOOL = fixBooleanValues(v);
            if (metadata && metadata.default) {
                metadata = metadataDefaultsMapGenerator(booleanMetadataGenerator, [metadata.default]);
            }
            if (!metadata || !metadata.format || typeof metadata.format !== 'object') {
                return v ? 'true' : 'false';
            }
            return React.createElement("span", { style: { color: FIXED_BOOL ? metadata.format.truthy.color : metadata.format.falsy.color } }, FIXED_BOOL ? metadata.format.truthy.label : metadata.format.falsy.label);
        case 'STR':
            const FIRST_VALUES = v.substring(0, 2);
            if (FIRST_VALUES === '- ' || FIRST_VALUES === '+ ') {
                return (React.createElement("span", { style: { color: FIRST_VALUES === '- ' ? '#990000' : '#009900' } }, v.split('\n').map((s, i) => (React.createElement("div", { key: i },
                    t(s),
                    React.createElement("br", null))))));
            }
            if (v === '...') {
                return React.createElement("span", { style: { color: '#999999' } }, v);
            }
            return v;
        case 'ARRAY':
            return (React.createElement(React.Fragment, null, v.map((v, i) => React.createElement("div", { key: `changes-array-${i}`, style: { paddingLeft: indentLevel > 1 ? indentLevel * 8 : 0 } }, renderValue(t, v, metadata, context, data, 1, undefined, `${path}.${i}`, field)))));
        case 'OBJ':
            return (React.createElement(React.Fragment, null, Object.keys(v).map((key, i) => {
                var _a;
                if (!((_a = context === null || context === void 0 ? void 0 : context.ignore) === null || _a === void 0 ? void 0 : _a.includes(key))) {
                    return (React.createElement("div", { style: { paddingLeft: indentLevel > 0 ? indentLevel * 8 : 0 }, key: `changes-object-prop-${i}` },
                        renderKey(t, indentLevel, key, entity, dictionary, path),
                        ' ',
                        renderValue(t, v[key], getMetadata(key, metadata), context, data, indentLevel + 1, undefined, path ? `${path}.${key}` : `${key}`, field)));
                }
            })));
        case 'template':
            const REGX = /\{(.*?)\}/g; // All words between curly braces { }
            const value = metadata && metadata.format && typeof metadata.format === 'string' ? metadata.format.replace(REGX, (matched, original) => {
                return v[original] || v;
            }) : v;
            return (React.createElement("div", null, value));
        default:
            return v;
    }
}
/**
 * Small utils
 */
const getMetadata = (key, metadata) => {
    if (!metadata) {
        return null;
    }
    if (metadata[key]) {
        return metadata[key];
    }
    return metadata['*'] || metadata;
};
export const isBoolean = (v) => {
    return (typeof v == 'boolean') || v === 'false' || v === 'true';
};
export const fixBooleanValues = (e) => {
    if (!e || e === ' ' || e === 'false')
        return false;
    return (e === true || e === 'true');
};
export const getType = (v) => {
    if (Array.isArray(v)) {
        return 'ARRAY';
    }
    if (isBoolean(v)) {
        return 'BOOL';
    }
    if (typeof v === 'string') {
        return 'STR';
    }
    if (typeof v === 'object') {
        return 'OBJ';
    }
    return 'INT';
};
export function renderKey(t, indentLevel, key, entity, dictionary, path) {
    const FINAL_PATH = path ? `${path}.${key}` : key;
    let translation = null;
    if (dictionary) {
        translation = _.get(dictionary, FINAL_PATH, null);
        if (!translation) {
            translation = _.get(dictionary, key, null);
        }
    }
    return (React.createElement("span", { style: { fontWeight: 'bold' } },
        translation || t(key),
        ":"));
}
export function getTranslatedValue(t, dictionary, v) {
    if (dictionary) {
        return;
    }
    return t(v);
}
//# sourceMappingURL=utils.js.map